import { Component, ViewEncapsulation, Input, Injector, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, ValidationErrors, AbstractControl, NgForm } from '@angular/forms';
import { __assign } from 'tslib';

@Component({
  selector: 'suffix',
  templateUrl: 'suffix.component.html',
  styleUrls: [],
  providers:
  [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SuffixComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SuffixComponent
    }
  ]
})
export class SuffixComponent implements OnInit, OnChanges, ControlValueAccessor, Validator {
  @ViewChild('form') form: NgForm;
  @Input() name = 'suffix';
  @Input() label = 'Suffix';
  @Input() required: boolean | string = false;
  @Input() labelClass: string;
  @Input() inputClass: string;
  @Input() disabled: boolean | string = false;
  @Input() flex: number | string = 10;

  innerValue: string;
  labelVisible = true;
  innerRequired: boolean;
  innerDisabled: boolean;
  availableValues = ['JR','SR','II','III','IV','V','VI','VII'];

  private onChange = (value: string) => {};
  private onTouched = () => {};
  private onValidateChange = () => {};

  constructor(private inj: Injector) {}

  ngOnInit(): void {
    const outerControl = this.inj.get(NgControl).control;
    const prevMarkAsTouched = outerControl.markAsTouched;
    const that = this;
    outerControl.markAsTouched = (...args: any) => {
        const control = that.getChildControl();
        control?.parent.markAllAsTouched();

        control?.updateValueAndValidity();

        prevMarkAsTouched.bind(outerControl)(...args);
      };
  }

  getChildControl(): any {
    let control = null;
    for (const k in this.form?.controls) {
      if (this.form.controls[k]) {
        control = this.form.controls[k];
      }
    }

    return control;
  }

  // Necessary if there is conditional binding on the required attribute
  resetValue(): void {
    const originalValue = this.value;
    this.value = null;
    this.value = originalValue;
    // this.picker.blur();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // Clear any previous validation errors, since we're changing setup parameters
    // for our control.
    setTimeout(() => this.getChildControl()?.setErrors(null), 0);

    if (changes && changes.required) {
      this.innerRequired = this.flagIsTrue(changes.required.currentValue);
    }

    if (changes && changes.disabled) {
      this.innerDisabled = this.flagIsTrue(changes.disabled.currentValue);
    }
  }

  private flagIsTrue(value: string | boolean): boolean {
    return value === true || value === '' || value === 'true';
  }

  innerChange(value: string): void {
    this.onChange(value);
  }

  // ControlValueAccessor - Write initial value into component.
  writeValue(value: any): void {
    if (value !== this.innerValue) {
      this.innerValue = value;

      this.onValidateChange();
    }
  }

  // ngModel two-way binding support (and also downstream value pass-through to kendo-datepicker)
  get value(): string {
    return this.innerValue;
  }

  // ngModel two-way binding support (and also downstream value pass-through to kendo-datepicker)
  set value(v: string) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.innerChange(v);
      this.onValidateChange();
    }
  }

  // ControlValueAccessor - Parent form changes disabled state.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // ControlValueAccessor - Parent form registers on change listener (is dirty)
  registerOnChange(fn): void {
    this.onChange = fn;
  }

  // ControlValueAccessor - Parent form registers on touched listener (is touched)
  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  // Validator - Parent form registers on validator change listener
  registerOnValidatorChange(fn): void {
    this.onValidateChange = fn;
  }

  // Validator - Parent form detects need to validate.
  validate(control: AbstractControl): ValidationErrors | null {
    const name = 'control';
    const errors: ValidationErrors = this.getChildControl()?.errors;

    return errors;
  }
}
